(function () {
  'use strict';

  function parseMoney(text) {
    var match = text.match(/^(\D*)([\d.,]+)(\D*)$/);
    if (!match) return null;

    var prefix = match[1];
    var suffix = match[3];
    var cleaned = match[2];
    var hasComma = cleaned.indexOf(',') > -1;
    var hasDot = cleaned.indexOf('.') > -1;
    var decimalSeparator = '.';

    if (hasComma && hasDot) {
      decimalSeparator = cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.') ? ',' : '.';
    } else if (hasComma && !hasDot) {
      decimalSeparator = ',';
    }
    var thousandsSeparator = decimalSeparator === ',' ? '.' : ',';

    var normalized = cleaned.split(thousandsSeparator).join('').replace(decimalSeparator, '.');
    var value = parseFloat(normalized);
    if (isNaN(value)) return null;

    var decimals = (normalized.split('.')[1] || '').length;
    return {
      prefix: prefix,
      suffix: suffix,
      cents: Math.round(value * 100),
      decimals: decimals,
      decimalSeparator: decimalSeparator,
      thousandsSeparator: thousandsSeparator
    };
  }

  function formatMoney(cents, meta) {
    var decimals = cents % 100 === 0 ? 0 : meta.decimals || 2;
    var fixed = (cents / 100).toFixed(decimals);
    var parts = fixed.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, meta.thousandsSeparator);
    var formatted = parts[1] ? intPart + meta.decimalSeparator + parts[1] : intPart;
    return meta.prefix + formatted + meta.suffix;
  }

  function updatePrice(quantityInput) {
    var row = quantityInput.closest('.product-form__quantity-row');
    if (!row) return;

    var quantity = parseInt(quantityInput.value, 10);
    if (!quantity || quantity < 1) quantity = 1;

    var priceEls = row.querySelectorAll(
      '[data-optional-addon-submit-price] .price__regular .price-item, ' +
        '[data-optional-addon-submit-price] .price__sale .price-item'
    );

    priceEls.forEach(function (el) {
      if (!el.dataset.unitPriceText) {
        el.dataset.unitPriceText = el.textContent.trim();
      }
      var meta = parseMoney(el.dataset.unitPriceText);
      if (!meta) return;
      el.textContent = formatMoney(meta.cents * quantity, meta);
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('.product-form__quantity-row .quantity__input');
    if (input) updatePrice(input);
  });
})();
